import './Lightbox.scss';
import Component from './Lightbox.js';
export default Component;